import cornerstone from 'cornerstone-core';
import csTools from 'cornerstone-tools';
import { PIXELS_NEAR_TOOL, PIXELS_NEAR_TOOL_TOUCH } from '~/constants';
import { pointInEllipse } from './cornestone.helpers';

const getHandleNearImagePoint = csTools.importInternal('manipulators/getHandleNearImagePoint');

/**
 * @public
 * @class EllipticalRoi
 * @memberof Tools.Annotation
 * @classdesc Tool for drawing elliptical regions of interest, and measuring
 * the statistics of the enclosed pixels.
 * @extends Tools.Annotation.EllipticalRoiTool
 * @author Ricardo Aguirre <ricardo.a.nava@gmail.com>
 * Created at 2022-03-16
 */
export default class CustomEllipticalRoi extends csTools.EllipticalRoiTool {
  name;
  constructor(props) {
    super(props);
  }

  /**
   *
   *
   * @param {*} element
   * @param {*} data
   * @param {*} coords
   * @returns {Boolean}
   */
  pointNearTool(element, data, coords, interactionType) {
    const hasStartAndEndHandles = data && data.handles && data.handles.start && data.handles.end;

    const validParameters = hasStartAndEndHandles;

    if (!validParameters) csTools.logger.warn(`invalid parameters supplied to tool ${this.name}'s pointNearTool`);
    if (!validParameters || data.visible === false) return false;

    const handleNearImagePoint = getHandleNearImagePoint(element, data.handles, coords, 6);

    if (handleNearImagePoint) return true;

    const distance = interactionType === 'mouse' ? PIXELS_NEAR_TOOL : PIXELS_NEAR_TOOL_TOUCH;
    const startCanvas = cornerstone.pixelToCanvas(element, data.handles.start);
    const endCanvas = cornerstone.pixelToCanvas(element, data.handles.end);

    const minorEllipse = {
      left: Math.min(startCanvas.x, endCanvas.x) + distance / 2,
      top: Math.min(startCanvas.y, endCanvas.y) + distance / 2,
      width: Math.abs(startCanvas.x - endCanvas.x) - distance,
      height: Math.abs(startCanvas.y - endCanvas.y) - distance,
    };

    const majorEllipse = {
      left: Math.min(startCanvas.x, endCanvas.x) - distance / 2,
      top: Math.min(startCanvas.y, endCanvas.y) - distance / 2,
      width: Math.abs(startCanvas.x - endCanvas.x) + distance,
      height: Math.abs(startCanvas.y - endCanvas.y) + distance,
    };

    const pointInMinorEllipse = pointInEllipse(minorEllipse, coords);
    const pointInMajorEllipse = pointInEllipse(majorEllipse, coords);

    if (pointInMajorEllipse && !pointInMinorEllipse) return true;

    return false;
  }
}
